import { useEffect, useState } from 'react'
import { AI_QUICK_PAGE_SIZE } from '~/configs'
import { GET_AI_ARTWORK_NEWEST_36 } from '~/graphqls/gqls'
import {
  AiArtworkOrderMode,
  AiCreateArtworkPattern,
  getAIArtWorkNewst36,
  getAIArtWorkNewst36Variables,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { getGraphData } from '~/utils'

export default function usePreviewData(pattern: AiCreateArtworkPattern) {
  const [data, setData] = useState<
    getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node[]
  >([])
  const [total, setTotal] = useState<number>(0)

  const queryAction = useImperativeQuery<
    getAIArtWorkNewst36,
    getAIArtWorkNewst36Variables
  >(GET_AI_ARTWORK_NEWEST_36)

  const fetchData = async ({ page }: { page: number }) => {
    try {
      const res = await queryAction({
        offset: (page - 1) * AI_QUICK_PAGE_SIZE,
        first: AI_QUICK_PAGE_SIZE,
        param: {
          orderMode: AiArtworkOrderMode.CREATETIME,
          patterns: [pattern],
        },
      })

      const list =
        getGraphData<getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node>(
          res.data.pictureGraph?.aiArtworkPage?.edges || []
        )

      setTotal(
        res.data.pictureGraph?.aiArtworkPage?.pageInfo?.totalCount as number
      )

      setData(list)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchData({ page: 1 })
  }, [])

  return {
    data,
    fetchData,
    total,
  }
}
